import { z } from 'zod'

// Accepts string (from input) or number (from API/defaultValues), transforms empty string to undefined
const optionalNumber = z
  .union([z.number(), z.string(), z.null(), z.undefined()])
  .transform((val) => {
    if (val === '' || val === null || val === undefined) return undefined
    const items = Number(val)
    return isNaN(items) ? undefined : items
  })
  .refine((val) => val === undefined || val > 0, { message: 'Deve ser maior que zero' })

// Accepts string or number for required fields
const requiredNumber = z
  .union([z.number(), z.string()])
  .transform((val) => Number(val))
  .refine((val) => !isNaN(val) && val > 0, { message: 'Deve ser um número positivo' })

export const campaignSchema = z.object({
  name: z.string().min(2, 'Nome deve ter pelo menos 2 caracteres'),
  description: z.string().optional(),
  rewardType: z.enum(['percentage', 'fixed']),
  rewardValue: requiredNumber,
  // Ensure strict validation for warranty days
  warrantyDays: requiredNumber
    .refine((val) => Number.isInteger(val), { message: 'Deve ser inteiro' })
    .refine((val) => val >= 1 && val <= 30, 'Entre 1 e 30 dias'),
  minOrderValue: optionalNumber,
  maxRewardValue: optionalNumber,
  autoRefundFraud: z.boolean().default(false),
  // Guru Specifics (mapped visually but stored in platformConfig)
  maxSubscriptionCycles: optionalNumber,
  // Yampi Specifics
  yampiOncePerCustomer: z.boolean().default(true),
  yampiAccumulate: z.boolean().default(false),
  yampiIgnorePromotionProducts: z.boolean().default(false),
  isActive: z.boolean().default(true),
})

export type CampaignFormInput = z.input<typeof campaignSchema>
export type CampaignFormOutput = z.output<typeof campaignSchema>
